import React from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import type { MatchDate } from "./types";
import { ModalProvider } from "../../contexts/ModalContext";
import { Accordion } from "../../UI/Accordion";
import { AccordionSummary } from "../../UI/AccordionSummary";
import { AccordionDetails } from "../../UI/AccordionDetails";

import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";
import { MatchingRoundBadge } from "../MatchingRoundStatus";
import { EnhancedTableBody } from "../EnhancedTableBody";
import { MatchDatesAccordionContent } from "./MatchDatesAccordionContent";


const AccordionStyles = {
  backgroundColor: 'rgba(250, 251, 252)',
  border: 'none',
  boxShadow: 'none',
  "&::before": {
    height: 0,
  }
};

const AccordionSummaryStyles = {
  border: 'none',
  boxShadow: 'none',
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: 'rotate(0deg)',
    color: 'black',
    float: 'left',
    position: 'absolute',
    left: "10px",
    top: "25px"
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    transform: 'rotate(-90deg)',
    color: 'black',
    float: 'left',
    position: 'absolute',
    left: "10px",
    top: "15px"
  },
  "& .MuiAccordionSummary-content": {
    "padding-left": "25px"
  }
};

const AccordionDetailsStyles = {
  "&.MuiAccordionDetails-root": {
    "padding-left": "40px"
  },
  border: 'none',
};

export const MatchDatesAccordionBody: React.FC<{rows: MatchDate[], isLoading: boolean}> = ({ rows, isLoading }) => (
  <EnhancedTableBody colSpan={3} isLoading={isLoading}>
    {rows.map((row, idx) => (
      <Accordion
        key={row.l2Name + idx}
        sx={AccordionStyles}
        defaultExpanded={!!(row.matchingRoundStatus !== "ARCHIVED")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={AccordionSummaryStyles}
        >
          
          <Grid container gap={2}>
            <Grid item>
            <Typography variant="h5" fontWeight={500}>
              {row.l2Name}
            </Typography>
            </Grid>
            <Grid item>
              <MatchingRoundBadge status={row.matchingRoundStatus as string} />
            </Grid>
          </Grid>
          
        </AccordionSummary>
        <AccordionDetails
          sx={AccordionDetailsStyles}
        >
          <ModalProvider key={`${row.l2Name}-${row.l2Id}`}>
            <MatchDatesAccordionContent {...row} />
          </ModalProvider>
        </AccordionDetails>
      </Accordion>
    ))}
  </EnhancedTableBody>
);
